const textFormattingPattern = /(\*\*)|(\b_)|(_\b)/gm
const hyperlinkPattern = /\[([^\[\]()]+)]\([^\[\]()]+\)/gm

export function stripMarkdown(text: string): string {
  return text.replace(textFormattingPattern, '').replace(hyperlinkPattern, '$1')
}
